
  import React from "react"
  import Component from "/Users/fabianbrenes/squidsource/src/layouts/en.js"
  import data from "/Users/fabianbrenes/squidsource/.cache/json/layout-en.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/en.js